import React from 'react';
import { Box, Typography } from '@heycater/design-system';
import { BoxProps } from '@material-ui/core';
import Image from 'next/image';
import { Trans, useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import image from '@images/food-program-page/what-is-it.png';
import { FoodProgramH2 } from 'static_pages/foodProgram/Utils';
import Container from 'system/components/Container';

const WhatIsFoodProgram = (props: BoxProps) => {
  const theme = useTheme();
  const { t } = useTranslation('food_program');
  return (
    <Container size={1050}>
      <Box
        as="section"
        display={'flex'}
        flexDirection={{ xs: 'column', md: 'row' }}
        alignItems={'center'}
        {...props}
      >
        <Box
          flexShrink={{ xs: 0.8, sm: 0.2, lg: 0 }}
          maxWidth={{ xs: 300, md: 'none' }}
        >
          <Image
            alt=""
            src={image}
            width={467}
            height={389}
            objectFit="cover"
          />
        </Box>
        <Box
          display="flex"
          ml={{ xs: 0, sm: 2, md: 6, lg: 8 }}
          flexDirection="column"
        >
          <FoodProgramH2 mb={1}>
            <Trans
              t={t}
              i18nKey="whatItIs.title"
              components={[
                <Box
                  key="1"
                  as="span"
                  color={{ xs: 'inherit', md: theme.palette.secondary[400] }}
                />,
              ]}
            />
          </FoodProgramH2>
          <Typography lineHeight={1.68} fontSize={{ xs: 14, sm: 16 }}>
            {t('whatItIs.description')}
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default WhatIsFoodProgram;
